var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTipIcon = function SvgTipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA2C19",
    d: "M0 0h12v12H0z",
    opacity: 0.01
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "gray"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 3.75,
    r: 0.75,
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M4.756 5.805c0-.164.133-.297.297-.297h.821c.013 0 .024.01.024.023v.548q-.002.021-.024.023h-.82a.297.297 0 0 1-.298-.297",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M5.417 5.716a.25.25 0 0 1 .246-.208h.294a.75.75 0 0 1 .74.875L6.284 8.82a.25.25 0 0 1-.247.208h-.293a.75.75 0 0 1-.74-.875z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M5.555 8.47a.05.05 0 0 1 .047-.04h1.047a.297.297 0 0 1 0 .595H5.514a.05.05 0 0 1-.05-.061z",
    clipRule: "evenodd"
  })));
};
export default SvgTipIcon;